// app.config.ts
import {ApplicationConfig, importProvidersFrom, LOCALE_ID} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';

import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { SwiperModule } from 'swiper/angular';
import { QuillModule } from 'ngx-quill';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      AppRoutingModule,
      SwiperModule,
      QuillModule.forRoot({
        customOptions: [
          {
            import: 'formats/font',
            whitelist: ['mirza', 'roboto', 'aref', 'serif', 'sansserif', 'monospace']
          }
        ]
      })
    ),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(
      withInterceptorsFromDi(),
      withFetch()
    ),
    { provide: LOCALE_ID, useValue: 'de' }
  ]
};
